import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const CopyIcon = ({size, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M15.8501 20.125C15.8501 20.4565 15.7184 20.7745 15.484 21.0089C15.2496 21.2433 14.9316 21.375 14.6001 21.375H5.8501C5.51858 21.375 5.20063 21.2433 4.96621 21.0089C4.73179 20.7745 4.6001 20.4565 4.6001 20.125V8.875C4.6001 8.54348 4.73179 8.22554 4.96621 7.99112C5.20063 7.7567 5.51858 7.625 5.8501 7.625H12.2076C12.5389 7.62507 12.8566 7.75665 13.0909 7.99083L15.4843 10.3842C15.7184 10.6185 15.85 10.9362 15.8501 11.2675V20.125Z"
					stroke="#535353"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.14014 7.625V3.875C8.14014 3.54348 8.27183 3.22554 8.50625 2.99112C8.74067 2.7567 9.05862 2.625 9.39014 2.625H15.7476C16.0789 2.62507 16.3966 2.75665 16.631 2.99083L19.0243 5.38417C19.2585 5.6185 19.3901 5.93621 19.3901 6.2675V15.125C19.3901 15.4565 19.2584 15.7745 19.024 16.0089C18.7896 16.2433 18.4717 16.375 18.1401 16.375H15.9001"
					stroke="#535353"
					strokeWidth="1.2"
					strokeinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</StyledSpan>
	);
};
CopyIcon.SIZE = SIZE;
CopyIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
